/**
 * Post that 
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { Link } from "gatsby"

class Post extends React.Component {
  render() {
    let post = this.props.post
    return (
      <article key={post.slug}>
        <header>
          <h3 className="mb-4">
            <Link style={{ boxShadow: `none` }} to={`/${post.slug}`}>
              {post.title}
            </Link>
          </h3>
          <small>{post.published_at}</small>
          &nbsp;
          <small>by</small>
          &nbsp;
          {post.authors.map(author => {
            return (
              <Link key={author.id} style={{ boxShadow: `none` }} to={`/authors/${author.id}`}>
                {author.name}
              </Link>
            )
          })}
        </header>
        <section>
          <p
            dangerouslySetInnerHTML={{
              __html: post.content.description || post.content.excerpt,
            }}
          />
          <p>
          {post.tags.map(tag => {
            return (
              <Link key={tag.id} style={{ boxShadow: `none` }} to={`/tags/${tag.slug}`}>
                {tag.name}
              </Link>
            )
          })}
          </p>
        </section>
      </article>
    )
  }
}

export default Post

